import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import React from 'react';
import { SyncList } from './SyncList';
import { SyncNowButton } from './SyncNowButton';
import { importsActions } from '@sonar-software/sonar-imports';
import { SonarCard, ViewArea } from '@ui/general';
import { useAction, useCurrentUser, useInterval, useOnMount, useSonarSelector } from '@hooks';
export const latestImportSelectors = createAsyncSelectors((state) => state.imports.latest.get);
export const SyncView = () => {
    const { isReadOnly } = useCurrentUser();
    const latestSyncs = useSonarSelector(latestImportSelectors.data);
    const getLatestSyncs = useAction(importsActions.requestGetImportsLatest);
    useOnMount(() => {
        getLatestSyncs({ count: 20 });
    });
    useInterval(() => {
        getLatestSyncs({ count: 20 });
    }, 10000);
    return (React.createElement(ViewArea, { direction: 'horizontal', fullHeight: true, fullWidth: true, id: 'syncs-view' },
        React.createElement(SonarCard, { extra: !isReadOnly && React.createElement(SyncNowButton, null), noSpacing: true, title: COPY_SPECIFIC.METADATA_IMPORT_LOGS },
            React.createElement(SyncList, { syncs: (latestSyncs !== null && latestSyncs !== void 0 ? latestSyncs : []) }))));
};
